module.exports = __webpack_public_path__ + "c4e262b5e2fa951c53e6af1623af7e78.png";